export default __webpack_public_path__ + "static/media/heart-icon-favorited.677b7587.svg";